<script setup>
import BaseIcon from "@/components/BaseIcon.vue";
import { ref } from "vue";
import MainRepository from "@/repositories/MainRepository.js";
import { useRouter } from "vue-router";
import BaseLoading from "@/components/BaseLoading.vue";
import ButtonPrimary from "@/components/buttons/ButtonPrimary.vue";
import ButtonPrimaryWithArrow from "@/components/buttons/ButtonPrimaryWithArrow.vue";
import BaseDialog from "@/components/BaseDialog.vue";
import ButtonSecondary from "@/components/buttons/ButtonSecondary.vue";
import StatisticsItemSelectorFailed from "@/components/statistics/StatisticsItemSelectorFailed.vue";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  percentage: {
    type: Number,
    required: true,
  },
  publicExamination: {
    type: Number,
    required: true,
  },
  contentLevels: {
    type: Array,
    required: true,
  },
  isFirst: {
    type: Boolean,
    default: false,
  },
  isLast: {
    type: Boolean,
    default: false,
  },
});

const router = useRouter();

const forceNew = true;
const type = "custom";
const dialogOpen = ref(false);
const isNewAttemptExecuting = ref(false);
const maxQuestions = 20;
const newAttemptDialog = () => {
  isNewAttemptExecuting.value = false;
  dialogOpen.value = true;
};

const data = {
  title: props.title,
  percentage: props.percentage,
  publicExamination: props.publicExamination,
  contentLevels: props.contentLevels,
  forceNew: forceNew,
  type: type,
  maxQuestions: maxQuestions,
};

async function newAttempt() {
  isNewAttemptExecuting.value = true;
  try {
    const newAttempt = MainRepository.newAttempt();
    const response = await newAttempt(data);
    move(response.data.uuid);
  } catch (error) {
    console.error("Error making the request:", error);
    isNewAttemptExecuting.value = true;
  } finally {
    dialogOpen.value = false;
  }
}

function move(uuid) {
  router.push({ name: "in-attempt", params: { uuid: uuid } });
}
</script>
<template>
  <statistics-item-selector-failed :title="title" :percentage="percentage" :isFirst="isFirst" :isLast="isLast">
    <template #actions>
      <a @click="newAttemptDialog" class="ml-auto cursor-pointer">
        <base-icon icon-name="edit_content_level_statistics" title="test personalizado" />
      </a>
    </template>
  </statistics-item-selector-failed>
  <base-dialog :is-open="dialogOpen">
    <template v-slot:default>
      <div class="mb-4 ml-1 mt-8">
        <h3 class="mb-4 text-3xl">Realizar test preguntas falladas {{ title }}</h3>
        <p>
          Se creará un test personalizado de hasta {{ maxQuestions }} preguntas para practicar el {{ title }}.<br />
          ¿Está seguro de que desea empezar el test?
        </p>
      </div>
    </template>
    <template v-slot:buttons>
      <base-loading :invisible="!isNewAttemptExecuting" :size="6"></base-loading>
      <button-secondary
        @click="dialogOpen = false"
        :disabled="isNewAttemptExecuting"
        class="mb-8 mr-4 rounded-[16px] border-none bg-[#DBE2FE] px-12 py-4 text-[#0035F5] hover:bg-[#DBE2FE]"
      >
        Cancelar
      </button-secondary>
      <button-primary-with-arrow
        @click="newAttempt"
        :disabled="isNewAttemptExecuting"
        class="mb-8 rounded-[16px] border-none bg-[#F39200] px-8 py-4 text-white hover:bg-[#F39200]"
      >
        <span v-if="!isNewAttemptExecuting">Empezar test</span>
        <span v-else>Creando test...</span>
      </button-primary-with-arrow>
    </template>
  </base-dialog>
</template>
